var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    viewBox: "0 0 100 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5273.1 2400.1v-2c0-2.8-5-4-9.7-4s-9.7 1.3-9.7 4v2c0 1.8.7 3.6 2 4.9l5 4.9c.3.3.4.6.4 1v6.4c0 .4.2.7.6.8l2.9.9c.5.1 1-.2 1-.8v-7.2c0-.4.2-.7.4-1l5.1-5c1.3-1.3 2-3.1 2-4.9zm-9.7-.1c-4.8 0-7.4-1.3-7.5-1.8.1-.5 2.7-1.8 7.5-1.8s7.3 1.3 7.5 1.8c-.2.5-2.7 1.8-7.5 1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5268.4 2410.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1s-.4-1-1-1h-4.3zM5272.7 2413.7h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1s-.4-1-1-1zM5272.7 2417h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1 0-.5-.4-1-1-1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M70.9 22.5H87c-.3-.5-.7-1-1.2-1.5L69.9 5.1c-.4-.4-.9-.8-1.5-1.2v16c0 1.5 1.1 2.6 2.5 2.6zM47.5 37.9c-.1-.2-.3-.4-.9-.4-.6 0-.7.2-.7.3-.6 1.4.1 4.5 1.5 7.8.9-4.2.8-6.7.1-7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9 29.2c-5.1 0-9.2-4.1-9.2-9.2V2.5H20.6c-2.4 0-4.6.9-6.3 2.6-1.7 1.7-2.6 3.9-2.6 6.3v77.1c0 4.9 4 8.9 8.9 8.9h58.9c4.9 0 8.9-4 8.9-8.9V29.2H70.9zm.3 36.9c-1.4 1.4-3.3 2.2-5.2 2.2-2.8 0-6.1-1.6-9.8-4.6-2 .4-4.2 1-6.8 1.7-2.2.6-4.1 1.3-5.8 1.9-3 5.4-6.9 10.9-10.6 11.8-.4.1-.8.2-1.2.2-1 0-1.9-.3-2.7-1-1.3-1.1-1.9-2.6-1.6-4.2.8-4.1 7.4-7.6 13.4-10 .8-1.5 1.5-3.1 2.2-4.7 1.2-3 2.2-5.7 2.9-8-2.8-5.2-5.1-11.6-3.5-15.1.8-1.7 2.3-2.7 4.3-2.7 1.8 0 3.2.7 4.1 2.1 1.8 2.6 1.5 7.7-.7 15.3 1 1.7 2.1 3.3 3.1 4.4 1.4 1.5 2.8 2.9 4.1 4 8-1.4 13.3-.8 14.9 1.8.2.6 1.1 2.6-1.1 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 55.8c-.6 1.6-1.2 3.3-1.9 5.1-.2.5-.4.9-.6 1.4.9-.3 1.6-.5 2.3-.7 1.5-.4 3-.8 4.3-1.2-.8-.7-1.5-1.5-2.3-2.4-.5-.5-1.1-1.3-1.8-2.2zM31.2 74.9c.3.5.4.5.7.5 1.4-.4 3.4-2.4 5.4-5.4-4 2-5.9 3.9-6.1 4.9zM61.6 62.7c1.7 1 3.2 1.6 4.5 1.6 1.1.1 1.9-.2 2.4-1s-2.1-1.1-6.9-.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewPdf);
export default __webpack_public_path__ + "static/media/view_pdf.3e654372caff141b1a74da401a30fbfc.svg";
export { ForwardRef as ReactComponent };